import React from 'react';
import { FileUploadButton as FileUploadButtonNew } from './FileUploadButton';
import { convertOldFileUploadButtonProps } from './converter.old';
import type { OldFileUploadButtonProps } from './converter.old';
export type FileUploadButtonProps = OldFileUploadButtonProps;
export const FileUploadButton = (props: FileUploadButtonProps) => (
  <FileUploadButtonNew {...convertOldFileUploadButtonProps(props)} />
);
